export const BRAND_COLOR = '#3498db';
export const BRAND_DARK = '#2980b9';
export const BRAND_LIGHT = '#e1f0ff';
export const BRAND_NAVY = '#0F172A';
export const BRAND_SLATE = '#64748b';
export const BRAND_CONTRAST = '#ffffff';
export const BG_LIGHT = '#f8fafc';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BRAND_COLOR,
  BRAND_DARK,
  BRAND_LIGHT,
  BRAND_NAVY,
  BRAND_SLATE,
  BRAND_CONTRAST,
  BG_LIGHT,
};
